import { FormActionButton } from '@workwave-tidal/core/form'

import { useResetEditingState } from '@/atoms'

import { form } from '../formState'
import { useRecurrencesMap } from '../hooks/useRecurrencesMap'
import { useTexts } from '../hooks/useTexts'
import { isAlreadyExistingRecurrence } from '../utils/isAlreadyExistingRecurrence'

export function Footer() {
  const recurrenceMap = useRecurrencesMap()
  const resetEditing = useResetEditingState()

  const texts = useTexts()

  const {
    meta: { submitting, validating },
  } = form.useFormMeta()
  const {
    field: { value },
  } = form.useFormField<'recurrence'>('recurrence')

  // When creating a new entity the submit button should be enabled also when the form is in a pristine status
  const saveDisabled = validating || submitting

  return (
    <>
      <FormActionButton
        label={texts.cancel}
        size="medium"
        onClick={resetEditing}
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
      />
      <FormActionButton
        label={
          value && isAlreadyExistingRecurrence(recurrenceMap, value)
            ? texts.openExistingTranslation
            : texts.setRecurrenceTranslation
        }
        disabled={saveDisabled}
        size="medium"
        variant="contained"
        type="submit"
        loading={submitting || validating}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
      />
    </>
  )
}
